import React from 'react';
import JitsiVideocalls from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const HelpButton = React.lazy(() => import('../../../components/HelpButton'));
const JitsiScheduledVideocalls = React.lazy(() =>
  import('./JitsiScheduledVideocalls')
);

const JitsiScheduledVideocallsPage = () => (
  <JitsiVideocalls>
    <ErrorBoundary>
      <React.Suspense fallback={<div />}>
        <>
          <div className="text-right">
            <HelpButton fileName="videocall-scheduled" />
          </div>
          <JitsiScheduledVideocalls />
        </>
      </React.Suspense>
    </ErrorBoundary>
  </JitsiVideocalls>
);

export default JitsiScheduledVideocallsPage;
